var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 47,
    fill: "url(#paint0_linear_2011_23)",
    stroke: "url(#paint1_radial_2011_23)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0264 75C33.157 75.0084 20.9916 62.8451 21 47.9736C21.0084 33.1549 33.157 21.0084 47.9736 21C62.8472 20.9916 75.0084 33.1528 75 48.0243C74.9916 62.843 62.8451 74.9895 48.0264 75ZM27.4497 48.0179C27.4666 59.3482 36.6308 68.5165 47.9673 68.5482C59.3144 68.5798 68.5672 59.3313 68.5482 47.9779C68.5292 36.6434 59.3714 27.4814 48.0327 27.4497C36.6835 27.4181 27.4328 36.6645 27.4497 48.0179Z",
    fill: "url(#paint2_radial_2011_23)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.397 47.9884C65.4075 57.6018 57.5574 65.4393 47.9566 65.3971C38.3622 65.357 30.6111 57.5912 30.6006 48.0095C30.5901 38.3961 38.4381 30.5628 48.041 30.6007C57.6375 30.6408 65.3864 38.4024 65.397 47.9884ZM47.9798 33.4734C47.3429 34.0808 46.7544 34.4288 46.4781 34.9434C45.4636 36.8248 44.5841 38.7799 43.5781 40.6655C43.3735 41.0493 42.8736 41.4395 42.4539 41.5155C40.349 41.8972 38.2293 42.1946 36.1096 42.4814C35.3546 42.5848 34.7429 42.8231 34.4898 43.5972C34.2388 44.3649 34.5658 44.9449 35.112 45.4701C36.6306 46.9296 38.1112 48.4313 39.6551 49.8634C40.1655 50.3379 40.2604 50.8083 40.1444 51.4452C39.7732 53.4805 39.461 55.5264 39.0751 57.5596C38.9317 58.3126 38.9717 58.9685 39.596 59.4641C40.2731 60.0041 40.9543 59.8248 41.6545 59.4473C43.5085 58.4518 45.3603 57.4478 47.2543 56.5388C47.6698 56.3384 48.3489 56.3468 48.7665 56.5493C50.631 57.4457 52.4491 58.4349 54.2734 59.4135C54.961 59.7826 55.6359 60.0294 56.3383 59.5105C57.0216 59.0043 57.0638 58.3231 56.912 57.5301C56.5302 55.5327 56.2497 53.5143 55.8532 51.5212C55.7034 50.7682 55.8954 50.281 56.4395 49.7727C57.9539 48.3596 59.4134 46.8874 60.9045 45.4511C61.4529 44.9217 61.8684 44.2552 61.4571 43.5908C61.1555 43.1036 60.5101 42.6417 59.9491 42.5321C57.8505 42.125 55.7266 41.8487 53.6049 41.5661C52.9848 41.4838 52.6325 41.2392 52.3605 40.6549C51.4557 38.7188 50.5192 36.7931 49.5005 34.9118C49.2284 34.4014 48.6273 34.066 47.9798 33.4734Z",
    fill: "url(#paint3_radial_2011_23)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3241 55.3281C53.0521 53.6809 52.9023 52.2826 52.5712 50.9285C52.3012 49.8191 52.6134 49.0598 53.4169 48.3174C54.4546 47.3577 55.4016 46.299 56.492 45.1769C54.8807 44.9365 53.4022 44.6834 51.9152 44.5083C51.0125 44.4029 50.4599 43.9726 50.0824 43.1564C49.4581 41.8023 48.7621 40.4778 47.9965 38.9381C47.3595 40.2205 46.7247 41.2687 46.3071 42.3971C45.746 43.9157 44.7463 44.5821 43.1539 44.6581C41.9623 44.715 40.779 44.9997 39.5811 45.1832C40.663 46.3201 41.6185 47.3957 42.6541 48.387C43.3838 49.0851 43.677 49.7938 43.4429 50.8209C43.1181 52.2383 42.9493 53.6893 42.6794 55.326C44.1684 54.5499 45.4887 53.9066 46.7605 53.1832C47.6147 52.6959 48.3782 52.6938 49.2324 53.1768C50.5084 53.9003 51.8267 54.5457 53.3241 55.3281Z",
    fill: "url(#paint4_radial_2011_23)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.325 55.3281C51.8275 54.5456 50.5093 53.9002 49.2354 53.1789C48.3812 52.6938 47.6177 52.698 46.7635 53.1852C45.4917 53.9108 44.1713 54.5519 42.6823 55.3281C42.9523 53.6914 43.121 52.2382 43.4458 50.823C43.6799 49.7959 43.3867 49.0872 42.657 48.3891C41.6214 47.3978 40.666 46.3221 39.584 45.1853C40.7841 44.9997 41.9652 44.7171 43.1568 44.6601C44.7492 44.5842 45.749 43.9177 46.31 42.3992C46.7276 41.2708 47.3624 40.2225 47.9994 38.9402C48.765 40.4798 49.461 41.8044 50.0853 43.1584C50.4608 43.9726 51.0155 44.4049 51.9182 44.5104C53.4051 44.6855 54.8836 44.9385 56.495 45.179C55.4046 46.301 54.4576 47.3598 53.4199 48.3195C52.6163 49.0619 52.302 49.8212 52.5741 50.9306C52.9031 52.2825 53.0529 53.6809 53.325 55.3281Z",
    fill: "url(#paint5_radial_2011_23)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2011_23",
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8178FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E1E1E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2011_23",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9909 31.9457) scale(66.7143 66.7141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2011_23",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9949 38.9695) scale(37.5268 37.5267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2011_23",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1961 42.1798) scale(24.1815 24.1816)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2011_23",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2164 44.3922) scale(11.7521 11.3901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2011_23",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2194 44.3936) scale(11.7521 11.3886)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1515,
    stopColor: "#F7CD70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9694,
    stopColor: "#F24303"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.28d56a60255ba29a494310d188b246fc.svg";
export { ForwardRef as ReactComponent };